export enum OrdersHistoryEnum {
  DATE = 'creationDate',
  STATUS = 'orderStatus',
  CREATOR = 'creator',
  COMMENT = 'comment',
}

export enum OrderStatus {
  NEW = 'New',
  PROCESSING = 'Processing',
  IN_PROGRESS = 'InProgress',
  DONE = 'Done',
  CANCELLED = 'Cancelled',
}

export enum OrderStatusApiValue {
  New = 0,
  Cancelled = 1,
  Processing = 2,
  InProgress = 3,
  Done = 4,
}
